import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationState, CorporationAlertsRepositoryServiceService } from 'reg-hub-common';

@Component({
    selector: 'app-management-options',
    templateUrl: './management-options.component.html',
    styleUrls: ['./management-options.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ManagementOptionsComponent {
    @Input() public loading: boolean = false;
    selectedIndex: number = 0;
    hasUserAccess: boolean = false;
    hasPartyAccess: boolean = false;
    hasBrandAccess: boolean = false;
    hasAlertAccess: boolean = false;
    corporationID: string = '';

    constructor(private activatedRoute: ActivatedRoute,
        private configurationState: ConfigurationState,
        private corporationAlertsRepo: CorporationAlertsRepositoryServiceService
    ) {}

    ngOnInit(): void {
        this.configurationState.getCorporationID().then(corporationID => {
            this.corporationID = corporationID;
        });

        this.configurationState.hasBrandManagementAccess().then(brandAccess => {
            this.hasBrandAccess = brandAccess;
        });

        // Clients can only change severities, so the tab only appears once RegHub has enabled an alert type for them
        this.configurationState.hasAlertManagementAccess().then(alertManagementAccess => {
            if (!alertManagementAccess) {
                return;
            }

            this.configurationState.getCorporationID().then(corporationID => {
                this.corporationAlertsRepo.getCorporationAlerts(corporationID, new HttpParams().set('enabled', true).set('pageSize', 1))
                    .subscribe({
                        next: corporationAlerts => this.hasAlertAccess = corporationAlerts.length > 0,
                        error: () => this.hasAlertAccess = false
                    });
            });
        });

        this.configurationState.hasUserManagementAccess().then(userAccess => {
            this.hasUserAccess = userAccess;
            this.configurationState.hasManageReusablePartyAccess().then(partyAccess => {
                this.hasPartyAccess = partyAccess;
                this.setDefaultTab();
            });
        })
    }

    setDefaultTab() {
        var defaultTab = this.activatedRoute.snapshot.queryParams['tab'];
        if (defaultTab !== null && defaultTab !== undefined)
        {
            switch(defaultTab)
            {
                case "reusableParties":
                    this.selectedIndex = 1;
                    break;
                case "userGroups":
                default:
                    this.selectedIndex = 0;
                    
            }
        }
    }
}